import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { UserAddOutlined, FileExcelOutlined } from '@ant-design/icons';

import Menu from 'components/common/Menu';
import ListTable from 'components/common/ListTable';
import withRole from 'components/common/withRole';
import SupervisorFilter, { defaultSupervisorFilter } from 'filters/SupervisorFilter';
import { usersMenuItems, filterClientColumns } from 'menus';
import { getSupervisorsList, getUser, importSupervisors } from 'actions/asyncActions';
import { openSupervisorModal, openImportModal } from 'actions/modalActions';
import { ADMIN, MARKETING_COORDINATOR } from 'constants/roles';
import PersonPhoto from 'components/common/cards/person/PersonPhoto';
import PersonLink from 'components/common/cards/person/PersonLink';
import { POST_SUPERVISOR, PUT_SUPERVISOR, IMPORT_SUPERVISORS } from 'constants/actionTypes';

const stateToProps = state => ({
    user: getUser.selectData(state)
});

@withRole
@connect(stateToProps, { openSupervisorModal, openImportModal })
export default class Supervisors extends Component {
    columns = [
        {
            key: 'icon',
            width: 40,
            render: item => <PersonPhoto person={item} />
        },
        {
            title: 'ФИО',
            key: 'fullName',
            render: item => <PersonLink type='supervisor' person={item} />
        },
        {
            title: 'Телефон',
            dataIndex: 'phone',
            key: 'phone'
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email'
        }, {
            title: 'Регион',
            dataIndex: ['_embedded', 'region', 'name'],
            key: 'region'
        }, {
            title: 'Город',
            dataIndex: ['_embedded', 'city', 'name'],
            key: 'city'
        },
        {
            title: 'Должность',
            dataIndex: ['_embedded', 'grade', 0, 'name'],
            key: 'grade'
        },
    ];

    getFilter() {
        const { user } = this.props;
        const [ role ] = user.roles;

        return role === MARKETING_COORDINATOR ? { region: user.region } : {};
    }

    getMenuControls() {
        const { openSupervisorModal, openImportModal, user } = this.props;
        const [ role ] = user.roles;

        return role === ADMIN && (
            <div>
                <Button
                    type='success'
                    icon={<FileExcelOutlined />}
                    onClick={() => openImportModal({
                        title: 'Импортировать супервайзеров',
                        action: importSupervisors,
                        withoutMonth: true
                    })}>
                    Импорт
                </Button>
                <Button type='primary' icon={<UserAddOutlined />} onClick={() => openSupervisorModal()}>Создать</Button>
            </div>
        );
    }

    render() {
        return (
            <div>
                <Menu
                    items={usersMenuItems(this.props.accessToFinances)}
                    controls={this.getMenuControls()} />
                <ListTable
                    filterForm={SupervisorFilter}
                    initialFilters={{...defaultSupervisorFilter, ...this.getFilter()}}
                    action={getSupervisorsList}
                    refreshActions={[POST_SUPERVISOR, PUT_SUPERVISOR, IMPORT_SUPERVISORS]}
                    tableColumns={filterClientColumns(this.props.isClient, this.columns)} />
            </div>
        );
    }
}
